import { render, staticRenderFns } from "./SettsContact.vue?vue&type=template&id=1a49497d"
import script from "./SettsContact.vue?vue&type=script&lang=js"
export * from "./SettsContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports